import { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import GlobalStyles from '@mui/material/GlobalStyles'
import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';

interface TitleProps {
  children?: React.ReactNode;
  big?: boolean;
  info?: string;
  subtitle?: string;
  notooltip?: boolean;
  minWidth?: number;
}


export default function Title({ children, big, info, notooltip, subtitle, minWidth }: TitleProps) {
  return (
    <Fragment>
      <GlobalStyles styles={{ '.MuiTooltip-popper[data-popper-placement*="bottom"] div': { backgroundColor: 'info.main', maxWidth: '150px' } }} />
      <Box sx={{
        display: 'flex',
        flex: '1 0',
        maxHeight: 30,
        alignItems: 'center',
        zIndex: 100,
        minWidth: minWidth? minWidth: 50,
        flexWrap: 'wrap',
        mb: minWidth ? 1 : 0,
        mt: minWidth ? 1 : 0,
        pb: {
          xs: '2px',
          sm: 0,
          md: 0
        }
      }}>


        <Typography variant={big ? 'h2' : 'h5'}
          color='#1D639F' 
          sx={{ 
            fontWeight: 600, 
            minWidth: 150,
            pr: 1,
          }}>
          {children}
        </Typography>

        {subtitle !== undefined && <Typography color="primary" sx={{
          fontSize: '11px', 
          color: 'text.primary',
          pl: {
            xs: 0,
            sm: 0,
            md: 3
          }
        }}>
          {subtitle}
        </Typography>}

        {notooltip ? '' : <Tooltip sx={{ maxWidth: 50 }} title={info ? info : ''}>
          <IconButton sx={{ padding: '0 0 0 0' }}>
            <InfoIcon sx={{ color: 'info.main', marginLeft: 2 }} />
          </IconButton>
        </Tooltip>}
      </Box>
    </Fragment>
  );
}